export { default as ShopIcon } from './icon/ShopIcon';
export { default as Referral } from './icon/Referral';

export { default as BenefitsIcon1 } from './icon/BenefitsIcon1';
export { default as BenefitsIcon2 } from './icon/BenefitsIcon2';
export { default as BenefitsIcon3 } from './icon/BenefitsIcon3';
export { default as BenefitsIcon4 } from './icon/BenefitsIcon4';
export { default as BenefitsIcon5 } from './icon/BenefitsIcon5';
export { default as BenefitsIcon6 } from './icon/BenefitsIcon6';

export { default as WayIcon1 } from './icon/WayIcon1';
export { default as WayIcon2 } from './icon/WayIcon2';
export { default as WayIcon3 } from './icon/WayIcon3';
export { default as WayIcon4 } from './icon/WayIcon4';
export { default as WayIcon5 } from './icon/WayIcon5';
export { default as WayIcon6 } from './icon/WayIcon6';

export { default as LockIcon } from './icon/LockIcon';
